import { confirm } from 'owa-confirm-dialog';
import folderStore from 'owa-folders';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';
/**
 * Moving and deleting items to/from Starred and Important folders should be blocked. We will show following message prompt to the user if these actions are performed on the client -
 * - Move/Delete from Important: “You can’t move or delete items from this folder”
 * - Move/Delete to Important:" You can’t move items to this folder"
 * - Move/Delete from Starred: “To remove an item from this folder, unflag it”
 * - Move to Starred: “To move an item to this folder, flag it”
 * @param sourceFolderId - Source folder id
 * @param destinationFolderId - Destination folder id
 * @returns true if the action was blocked, false otherwise
 */
export default function handleBlockActionForShadowMailbox(sourceFolderId, destinationFolderId) {
    if (!getUserConfiguration().SessionSettings.IsShadowMailbox) {
        return false;
    }
    var message;
    var sourceFolder = folderStore.folderTable.get(sourceFolderId);
    var destinationFolder = folderStore.folderTable.get(destinationFolderId);
    var sourceFolderType = sourceFolder.sourceWellKnownFolderType;
    if (sourceFolderType == 87 /* Important */) {
        message = strings.blockActionFromImportantFolder;
    }
    else if (sourceFolderType == 88 /* Starred */) {
        message = strings.blockMoveDeleteFromStarredFolder;
    }
    else if (destinationFolder != null) {
        var destinationFolderType = destinationFolder.sourceWellKnownFolderType;
        if (destinationFolderType == 87 /* Important */) {
            message = strings.blockActionToImportantFolder;
        }
        else if (destinationFolderType == 88 /* Starred */) {
            message = strings.blockMoveToStarredFolder;
        }
    }
    if (message != undefined) {
        confirm('', message, false, {
            hideCancelButton: true,
        });
        return true;
    }
    return false;
}
//# sourceMappingURL=handleBlockActionForShadowMailbox.js.map